import { render, staticRenderFns } from "./AI-Personal-Operate.vue?vue&type=template&id=5d4ecb3f&scoped=true&"
import script from "./AI-Personal-Operate.vue?vue&type=script&lang=js&"
export * from "./AI-Personal-Operate.vue?vue&type=script&lang=js&"
import style0 from "./AI-Personal-Operate.vue?vue&type=style&index=0&id=5d4ecb3f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4ecb3f",
  null
  
)

export default component.exports